import { Outlet } from 'react-router-dom'
import BackgroundOrbs from './BackgroundOrbs'
import MortgageHeader from './MortgageHeader'
import MortgageFooter from './MortgageFooter'
import GoogleAnalytics from '../GoogleAnalytics'

export default function MortgageLayout() {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <GoogleAnalytics />
      <BackgroundOrbs />
      <MortgageHeader />
      <main className="flex-1 w-full relative z-[1]">
        <Outlet />
      </main>
      <MortgageFooter />
    </div>
  )
}
